<template>
  <div class="scroll-indicator">
    <div class="scroll"></div>
  </div>
</template>

<script>
export default {
  name: "ScrollDownIndicator"
}
</script>


<style scoped lang="scss">
@import "~@/assets/css/base.mixins";
@import "~@/assets/css/base.variables";

.scroll-indicator {
  @include position-elevation(absolute, $right: 110px, $bottom: 55px, $elevation: var(--scroll-indicator-index));
  transform:  rotate(-45deg);
}

.scroll {
  width: 24px;
  height: 24px;
  margin-left: -12px;
  border-left: 3px solid #fff;
  border-bottom: 3px solid #fff;
  -webkit-animation: sdb04 2s infinite;
  animation: sdb04 2s infinite;
  box-sizing: border-box;
}

@-webkit-keyframes sdb04 {
  0% {
    -webkit-transform: translate(0, 0);
  }
  20% {
    -webkit-transform: translate(-10px, 10px);
  }
  40% {
    -webkit-transform: translate(0, 0);
  }
}

@keyframes sdb04 {
  0% {
    transform: translate(0, 0);
  }
  20% {
    transform: translate(-10px, 10px);
  }
  40% {
    transform: translate(0, 0);
  }
}

</style>
